<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information" style="padding-top:200px">
<p><em>Where do words come from?</em></p>
<p><em>from what rubbing of sounds are they born</em></p>
<p><em>on what flint do they light their wicks</em></p>
<p><em>what winds brought them into our mouths?</em></p>
<p style="text-align: right;"><em>—Words</em> by Venus Khoury-Ghata</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?a615522a